import React from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import { withRouter } from 'react-router-dom';

import withMedia from '~/modules/core/utils/mediaHelpers/withMedia';
import Button from '~/modules/coreUI/components/basic/Button';
import { LinearLayout } from '~/modules/coreUI/components/layouts/helpers/LinearLayout';
import withUserInfo from '~/modules/core/utils/accessManagementHelpers/withUserInfo';
import { navigateToModal } from '~/modules/core/utils/modalHelpers';

import Cart from '../buttons/Cart';


const redirectToLogin = (history) => {
  navigateToModal(history, '/accountManagement/login');
};

const CartActions = (props) => {
  const viewAsColumn = props.vertical || props.media.xsmall;
  return (
    <LinearLayout row={!viewAsColumn} fullWidth spaceBetween={1.5}>
      {!props.authenticated && (
        <Button md block primary inverted iconName="icon-smart-cart" onClicked={() => redirectToLogin(props.history)}>
          {i18next.t('ecommerceOrder:Cart.addToSmart')}
        </Button>
      )}
      <Cart variantId={props.variantId} viewAsColumn={viewAsColumn} variant={props.variant} />
    </LinearLayout>
  );
};


CartActions.propTypes = {
  variantId: PropTypes.string.isRequired,
  vertical: PropTypes.bool,
  media: PropTypes.shape(),
  variant: PropTypes.shape({}).isRequired,
  authenticated: PropTypes.bool.isRequired,
  history: PropTypes.shape({}).isRequired,
};

CartActions.defaultProps = {
  vertical: false,
  media: {},
};

export default withRouter(withMedia(withUserInfo(CartActions)));
